import React, { FC, memo, useState } from 'react';
import ErrorMessage from '../errorMessage';
import { CardExpiryElement } from '@stripe/react-stripe-js';
import { StripeCardExpiryElementChangeEvent, StripeCardExpiryElementOptions } from '@stripe/stripe-js';
import { getCardFieldOptions } from '../../constants';
import classnames from 'classnames';
import s from './index.module.scss';
import locales from '../../../../../../../../../../content.json';

type Props = {
  className?: string;
  onChange?: (event: StripeCardExpiryElementChangeEvent) => void;
  options?: StripeCardExpiryElementOptions;
};

const CardExpire: FC<Props> = props => {
  const { className, onChange, options = getCardFieldOptions() } = props;
  const [empty, setEmpty] = useState<boolean | undefined>(false);
  const [error, setError] = useState<string | undefined>();

  const handleChange = (event: StripeCardExpiryElementChangeEvent) => {
    setError(event.error?.message);
    onChange && onChange(event);
    setEmpty(event.empty);
  };

  return (
    <>
       <div className={classnames(className, s.cardExpiry, { [s.empty]: empty })}>
        <CardExpiryElement onChange={handleChange} options={options} onFocus={() => setEmpty(true)} onBlur={() => setEmpty(false)}/>
        {empty && (
          <span className={s.cardExpiry_title}>{locales[window.userLang].payment_text_106}</span>
        )}
      </div>
      {error && <ErrorMessage error={error} />}
    </>
  );
};

export default memo(CardExpire);
